export default "__VITE_ASSET__vD83EP77__"